var getFieldDataState = function getFieldDataState(error) {
  return error ? "error" : "ok";
};

export default getFieldDataState;